import { useState } from 'react'

import { Icon } from './Icon'

const questions = [
  {
    id: 'cima',
    question: 'Can CIMA professionals enquire?',
    answer: 'Yes. CA(SA) professionals are our primary focus, but CIMA professionals and people on other credible finance qualification pathways are welcome to enquire. Every profile is reviewed by a person.',
  },
  {
    id: 'us-hours',
    question: 'Will I need to work US-aligned hours?',
    answer: 'Some roles require it and others may not. Where required, working hours are often approximately 14:00–22:00 or 15:00–23:00 SAST, depending on the client and daylight saving.',
  },
  {
    id: 'after-submit',
    question: 'What happens after I submit?',
    answer: 'You receive an acknowledgement immediately. Ark reviews your information and, if there may be a fit, contacts you by email and phone for an initial screening conversation. An enquiry is not a guaranteed vacancy or offer.',
  },
  {
    id: 'primary-audience',
    question: 'Who is Ark primarily looking for?',
    answer: 'Our primary audience is qualified CA(SA) professionals who can thrive in dedicated remote roles with international accounting and audit teams. Relevant CIMA and other finance professionals may also enquire.',
  },
  {
    id: 'remote',
    question: 'Is the work fully remote?',
    answer: 'Yes. Our initial offering is full-time, dedicated remote work from South Africa. The client provides the equipment, systems, role-specific training and day-to-day team environment.',
  },
  {
    id: 'sharing',
    question: 'Will Ark share my information with clients?',
    answer: 'Not from this enquiry alone. If a suitable opportunity arises, Ark will ask for separate permission before sharing identifiable profile information or your CV with a client.',
  },
]

export function ProfessionalFaq() {
  const [openId, setOpenId] = useState('cima')

  return (
    <section className="section professional-faq" id="professional-faqs" aria-labelledby="professional-faq-title">
      <div className="container professional-faq-layout">
        <div className="professional-faq-heading reveal">
          <p className="section-number">Questions, answered</p>
          <h2 className="section-title" id="professional-faq-title">Know what to expect before you enquire.</h2>
        </div>
        <div className="professional-faq-list reveal">
          {questions.map((item, index) => {
            const open = openId === item.id
            return (
              <article className={`faq-item${open ? ' is-open' : ''}`} key={item.id}>
                <button
                  className="faq-question"
                  type="button"
                  aria-expanded={open}
                  aria-controls={`professional-answer-${item.id}`}
                  onClick={() => setOpenId(open ? '' : item.id)}
                >
                  <span className="faq-symbol">{String(index + 1).padStart(2, '0')}</span>
                  <span>{item.question}</span>
                  <Icon className="faq-chevron" name="chevron" />
                </button>
                <div
                  className="faq-answer"
                  id={`professional-answer-${item.id}`}
                  aria-hidden={!open}
                  hidden={!open}
                >
                  <div><p>{item.answer}</p></div>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
